import React, { Component } from 'react';
import Navbars from '../components/navbars/Navbars';
import AsideNavbar from '../components/navbars/AsideNavbar';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import StudentPerformanceCharts from '../components/studentPerformanceCharts/StudentPerformanceCharts';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import moment from 'moment';


const FETCH_GET_SUBJECTS = gql`
  query($student_user_exam_id: Int!) {
    getSubjects(student_user_exam_id: $student_user_exam_id) {
      id
      subject
    }
  }
`;

class StudentOverallPerformance extends Component {
    constructor(props) {
        super(props);

        let start = moment(new Date()).subtract(1, "month");
        let end = moment(new Date());

        let sdate = String(start._d);

        var sres = sdate.substr(4, 11);
   

        let edate = String(end._d);
        var eres = edate.substr(4, 11);

        let startDate = sres + " 00:00:00";
        let endDate = eres + " 23:59:59";

        const stimestamp = moment(startDate, "MMM DD YYYY hh:mm:ss").unix();
        const etimestamp = moment(endDate, "MMM DD YYYY hh:mm:ss").unix();

        this.state = {
            toggled: isMobile == true && Cookies.get("institution_id") == 30 ? "wrapper" : Cookies.get("toggle"),
            selectExamType: { value: 0, label: 'ALL' },
            startDate: startDate,
            endDate: endDate,
            stimestamp: stimestamp,
            etimestamp: etimestamp,
            examTypes: [
                { value: 0, label: "All Exams" },
                { value: 1, label: "Mock Test" },
                { value: 2, label: "Custom Exam" },
                { value: 3, label: "Scheduled Exam" },
                { value: 4, label: "Error Exam" },
                { value: 5, label: "Previous Year Paper" },
                { value: 6, label: "Practice Test" }
            ],
        }
    }

    menuToggler = () => {
        const toggled = this.state.toggled;
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    applyCallback = (startDate, endDate) => {
        console.log("applyCallback", startDate, endDate);
        let sdate = String(startDate._d);
        var sres = sdate.substr(4, 20);

        let edate = String(endDate._d);
        var eres = edate.substr(4, 20);

        const stimestamp = moment(sres, "MMM DD YYYY hh:mm:ss").unix();
        const etimestamp = moment(eres, "MMM DD YYYY hh:mm:ss").unix();

        this.setState({
            startDate: sres,
            endDate: eres,
            stimestamp: stimestamp,
            etimestamp: etimestamp
        });
    }

    selecthandleInputChange = (ename, evalue) => {
        if (ename === "selectExamType") {
            const subjectData = this.state.examTypes.find(
                (a) => +a.value === +evalue
            );

            if (subjectData) {
                this.setState({
                    selectExamType: {
                        value: subjectData.value,
                        label: subjectData.label
                    }
                });
            }
        }
    };


    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");

        let studentGlobals = "";
        if (JSON.parse(localStorage.getItem("studentglobals")) != "") {
            studentGlobals = JSON.parse(localStorage.getItem("studentglobals"));
        }
        else {
            this.props.history.push("/student/login");
        }

        const getSubjects = this.props.getSubjects;
        const loading1 = getSubjects.loading;
        const error1 = getSubjects.error;
        if (loading1) return null;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }


        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <Navbars onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper bg-white scrolling">
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0">
                        <StudentPerformanceCharts stateData={this.state} handleChange={this.selecthandleInputChange} getSubjects={getSubjects.getSubjects} applyCallback={this.applyCallback} />
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(
    compose(
        graphql(FETCH_GET_SUBJECTS, {
            options: (props) => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
                }
            }),
            name: "getSubjects"
        })
    )(StudentOverallPerformance)
);